// =========================================
// 🔹 TYPES
// =========================================

export type PlanType = "free" | "pro" | "agency"

// =========================================
// 🔥 SINGLE SOURCE OF TRUTH
// =========================================

export const PLAN_CONFIG: Record<PlanType, {
  maxFileSize: number
  maxActions: number
  downloadsPerDay: number
  maxRowsPerFile: number
  maxRowsPerMonth: number

  // 🔥 worker / queue
  concurrency: number
  queue: string

  // 🔥 pricing (source of truth — consumed by pricing page + admin MRR estimate)
  priceMonthly: number
}> = {
  free: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    maxActions: 1,
    downloadsPerDay: 1,
    maxRowsPerFile: 1000,
    maxRowsPerMonth: 1000,

    concurrency: 1,
    queue: `jobs:free${process.env.QUEUE_SUFFIX ?? ""}`,

    priceMonthly: 0,
  },

  pro: {
    maxFileSize: 200 * 1024 * 1024, // 200MB
    maxActions: -1,
    downloadsPerDay: -1,
    maxRowsPerFile: 100000,
    maxRowsPerMonth: 100000,

    concurrency: 2,
    queue: `jobs:pro${process.env.QUEUE_SUFFIX ?? ""}`,

    priceMonthly: 29,
  },

  agency: {
    maxFileSize: 1024 * 1024 * 1024, // 1GB
    maxActions: -1,
    downloadsPerDay: -1,
    maxRowsPerFile: 1000000,
    maxRowsPerMonth: 1000000,

    concurrency: 3,
    queue: `jobs:agency${process.env.QUEUE_SUFFIX ?? ""}`,

    priceMonthly: 79,
  },
}

/**
 * Optional environment-scoped queue suffix.
 *
 * Local dev and Railway prod share the same Upstash Redis, so without a
 * suffix both workers race for the same `jobs:*` lists and Railway
 * usually wins (it's always warm). Set `QUEUE_SUFFIX=:dev` in
 * `.env.local` so the local Next API enqueues to `jobs:agency:dev` and
 * the local worker — also reading the same env file — pops from there.
 * Production leaves it unset → falls back to the canonical `jobs:agency`.
 */
export const QUEUE_SUFFIX = process.env.QUEUE_SUFFIX ?? ""

/** Helper: `{ free: 0, pro: 29, agency: 79 }` — convenient for MRR math. */
export const PLAN_PRICES_MONTHLY: Record<PlanType, number> = {
  free:   PLAN_CONFIG.free.priceMonthly,
  pro:    PLAN_CONFIG.pro.priceMonthly,
  agency: PLAN_CONFIG.agency.priceMonthly,
}

// =========================================
// 🔁 BACKWARD COMPATIBILITY (🔥 CLAVE)
// =========================================

// 👉 esto evita romper todo tu código actual
export const PLAN_LIMITS = PLAN_CONFIG

// =========================================
// 🔥 OPTIONAL HELPERS (PRO)
// =========================================

export function getPlanConfig(plan: PlanType) {
  return PLAN_CONFIG[plan]
}

export const PLAN_ORDER: PlanType[] = ["agency", "pro", "free"]